import { render, staticRenderFns } from "./SliderList.vue?vue&type=template&id=66008fc8&scoped=true"
import script from "./SliderList.vue?vue&type=script&lang=js"
export * from "./SliderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66008fc8",
  null
  
)

export default component.exports